import React, { useEffect } from "react";
import { KindInterface } from "src/store/community/kindsSlice";

import { Button, Form, Input } from "antd";
import FileDropzone from "src/componets/FileDropzone";

interface propsInterface {
  params: KindInterface;
  onFinish: Function;
}

const _Form = ({ params, onFinish }: propsInterface) => {
  const [form] = Form.useForm();

  useEffect(() => {
    form.resetFields();
  }, [params, form]);

  return (
    <Form
      form={form}
      onFinish={values => onFinish(values)}
      layout="vertical"
      className='v-form'
      initialValues={params}
    >
      <div className='v-group-dropzone'>
        <FileDropzone name='thumbnail' label='Thumbnail' preview={params?.thumbnail_url} />
      </div>

      <Form.Item name='app_id' noStyle>
        <Input type="hidden" />
      </Form.Item>

      <Form.Item name='target' noStyle>
        <Input type="hidden" />
      </Form.Item>

      <Form.Item name='name' label="Name">
        <Input placeholder='Name' />
      </Form.Item>

      <Form.Item
        name='slug'
        label="Slug"
        tooltip='Convention key used by the mobile app to request this kind. Generated from the name when left empty.'
      >
        <Input placeholder='auto-generated from name' />
      </Form.Item>

      <Form.Item>
        <Button className="v-btn v-btn-primary" type="primary" htmlType="submit">
          Submit
        </Button>
      </Form.Item>
    </Form>
  )
}

export default _Form;
